import { isHmrInProgress } from './internal/isHmrInProgress';
import { ObservableState } from './observableState';
import { stateStreamRegistry } from './stateStreamRegistry';
import { Observable } from 'rxjs';

/**
 * Wrapper function to register and convert a stream to a persistent state stream.
 *
 * See `persistentReducedStream` for more details about persistent streams.
 */
export const toPersistentStream = <State>(
  name: string,
  source$: Observable<State>,
  initialState: State
) => {
  const stream = new ObservableState(name, source$, initialState);
  if (isHmrInProgress()) {
    stateStreamRegistry.reRegister(stream);
  } else {
    stateStreamRegistry.register(stream);
  }
  return stream;
};
